import UserTemplate from './template/UserTemplate'

const AdminPage = (props) => {

  return (
    <>
      <UserTemplate   login={props.login} index={1} title={"システム管理者一覧"} />
    </>
  );

}

export default AdminPage;